import { Ng2StateDeclaration } from "@uirouter/angular";
import { ErrorOopsPageComponent } from "./error.oops.component";

export const errorOopsStateDeclaration: Ng2StateDeclaration = {
  name: 'error.oops',
  url: "/",
  component: ErrorOopsPageComponent
}
